import { apiClient } from '../utils/api-client';
import type { InsightClimbType, UserInsight, UserInsightResponse } from '../types/insight';

class InsightsService {
  async getUserInsights(userSlug: string, climbType: InsightClimbType): Promise<UserInsight> {
    const response = await apiClient.get(
      `/api/users/${userSlug}/insights?climb_type=${climbType}`
    );
    const body: UserInsightResponse = await response.json();
    return body.data.attributes;
  }
}

export const insightsService = new InsightsService();
